import { environment } from '@environments/environment';

export const baseUri = `${environment.apiUri}/biv-real-estate-agent`;
export const bivRealEstateAgentUri = `${baseUri}/:id`;
